import { Typeahead } from 'react-bootstrap-typeahead';
import { Card, CardBody, Col, Form } from 'reactstrap';
import { TypeAheadProps } from '../../../../../../types/Forms';
import CommonCardHeader from '../../../../../../coreComponents/CommonCardHeader';
import { useState } from 'react';

const CommonTypeAhead: React.FC<TypeAheadProps> = ({
  title,
  subTitle,
  options,
  placeholder,
  labelKey,
  className,
  id,
  onChange,
  disabled,
  selected
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={title} span={subTitle} />
        <CardBody>
          <div>
            <Form className="theme-form">
              <div className={className}>
                <Typeahead
                  id={id}
                  options={options}
                  labelKey={labelKey}
                  placeholder={placeholder}
                  onChange={(selected) => {
                    setIsFocused(false);
                    if (onChange && selected) {
                      onChange(selected);
                    }
                  }}
                  disabled={disabled}
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                  open={isFocused}
                  selected={selected}
                />
              </div>
            </Form>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default CommonTypeAhead;
